// extracted by mini-css-extract-plugin
export default {"wrapper":"UIConfigurationView_wrapper__6jXT4"};